import Api from '../../shared/Api';

export default class StatisticsApi {
    static newSearch(): Promise<any> {
        return new Api().get('/views/statistics');
    }

    static search(data: any): Promise<any> {
        return new Api().post('/views/statistics', data);
    }

    static exportExcel(data: any): Promise<any> {
        return new Api().downloadFilePost('/views/statistics/export', data);
    }
}
